"use client"

import "swiper/css"
import "swiper/css/autoplay"
import { getUmbracoMediaUrl } from "utils"

import styled from "@emotion/styled"
import Image from "next/image"
import { useEffect, useState } from "react"
import Stories from "react-insta-stories"

type Props = {
  data: any
  setFirstSlide?: any
  isPaused?: boolean
}

const StyledTopShadow = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  height: 30% !important;
  z-index: 1;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0) 100%
  );
`

const StorySlider = ({ data, setFirstSlide, isPaused }: Props) => {
  const stories = data.map((item: { url: string }) =>
    getUmbracoMediaUrl(item.url),
  )

  const [opacity, setOpacity] = useState(0)

  const progressContainerStyles = {
    height: "4px",
  }

  const progressWrapperStyles = {
    direction: "rtl",
    height: "4px",
    background: "rgba(255, 255, 255, 0.5)",
    opacity: opacity,
    transition: "opacity 0.3s ease-in-out",
  }

  const progressStyles = {
    transformOrigin: "right center",
    height: "4px",
    opacity: opacity,
    transition: "opacity 0.3s ease-in-out",
  }
  const storyStyles = {
    width: "100%",
    height: "100%",
  }

  const HandleStoryEnd = (index: number) => {
    if (index === 0) setFirstSlide && setFirstSlide(true)
    else setFirstSlide && setFirstSlide(false)
  }

  useEffect(() => {
    setTimeout(() => {
      setOpacity(1)
    }, 100)
  }, [])

  return (
    <div>
      <StyledTopShadow />
      <Stories
        stories={stories}
        progressContainerStyles={progressContainerStyles}
        progressWrapperStyles={progressWrapperStyles}
        progressStyles={progressStyles}
        loop
        storyContainerStyles={storyStyles}
        storyStyles={storyStyles}
        width={"100%"}
        height={"100%"}
        defaultInterval={3000}
        isPaused={isPaused}
        loader={<Image src={stories[0]} fill alt="loader" />}
        onStoryStart={HandleStoryEnd}
      />
    </div>
  )
}

export default StorySlider
